module.exports = __webpack_public_path__ + "img/moeRegistration2.b69a6ff8.png";